import React, {useState, useEffect} from 'react'
import OpenAiCustomData from '../whitaijiFrontendLibrary/components/OpenAiCustomData'
import BlueButton from '../components/BlueButton';
import { useStateContext } from '../context/StateContext';
import * as pdfjsLib from 'pdfjs-dist';
import { getDocument } from 'pdfjs-dist/webpack';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import ClaudeAiCustomData from '../whitaijiFrontendLibrary/components/ClaudeAiCustomData';
import { isGodMode, NoAccess } from '../utils/permissions';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';


pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;


const BookWriting = () => {

  const {hideTestButtons} = useStateContext()
  const [customData, setCustomData] = useState([]);
  const [aiData, setAiData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const {user} = useAuthContext(AuthContext)

  useEffect(() => {
    const loadPdfContent = async () => {
      try {
        process.env.NODE_ENV === "development" && console.log('Starting to load PDF...');
        // Load the PDF file
        const response = await fetch('/aiReferenceDocs/reMind Book.pdf');
        process.env.NODE_ENV === "development" && console.log('Fetch response:', response);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const arrayBuffer = await response.arrayBuffer();
        process.env.NODE_ENV === "development" && console.log('PDF array buffer loaded');
        
        // Load PDF document
        process.env.NODE_ENV === "development" && console.log('Creating PDF loading task...');
        const loadingTask = getDocument({ data: arrayBuffer });
        const pdf = await loadingTask.promise;
        process.env.NODE_ENV === "development" && console.log('PDF document loaded, number of pages:', pdf.numPages);
        
        // Extract text from each page
        const textContent = [];
        for (let i = 1; i <= pdf.numPages; i++) {
          process.env.NODE_ENV === "development" && console.log(`Processing page ${i}...`);
          const page = await pdf?.getPage(i);
          const content = await page?.getTextContent();
          const pageText = content?.items
            ?.map(item => item?.str)
            ?.join(' ')
            ?.trim();
          
          if (pageText) {
            textContent.push(pageText);
            process.env.NODE_ENV === "development" && console.log(`Page ${i} text extracted, length: ${pageText.length} characters`);
          }
        }
        
        process.env.NODE_ENV === "development" && console.log('PDF text extraction complete. Total pages processed:', textContent.length);
        setCustomData(textContent);
      } catch (error) {
        process.env.NODE_ENV === "development" && console.error('Error loading PDF:', error);
        process.env.NODE_ENV === "development" && console.error('Error details:', {
          name: error.name,
          message: error.message,
          stack: error.stack
        });
        setCustomData(['Error loading PDF content']);
      } finally {
        setIsLoading(false);
      }
    };

    loadPdfContent();
  }, []);

  const aiCopywriterPrompt =  `
      You are an AI copyeditor and an expert psychologist and coach.
    You have a keen eye for detail and a deep understanding of language, style, and grammar. 

    Your task is to take the lyrics pro and improve written content provided by users, offering advanced copyediting techniques and suggestions 
    to enhance the overall quality of the text. When a user submits a piece of writing, follow these steps:
    1. Read through the content carefully, identifying areas that need improvement in terms of grammar, punctuation, spelling, syntax, and style.
    2. Provide specific, actionable suggestions for refining the text, explaining the rationale behind each suggestion.
    3. Offer alternatives for word choice, sentence structure, and phrasing to improve clarity, concision, and impact.
    4. Ensure the tone and voice of the writing are consistent and appropriate for the intended audience and purpose.
    5. Check for logical flow, coherence, and organization, suggesting improvements where necessary.
    6. Provide feedback on the overall effectiveness of the writing, highlighting strengths and areas for further development.
    
    Your suggestions should be constructive, insightful, and designed to help the user elevate the quality of their writing. Avoid introductions, explanations, or instructions so 
    that it is easy to copy and paste the analysis.
    write your analysis in a poetic way but with simple words, mention the psychologists you get your inspiration from.
  `
  const aiPrompt =  `
    You are an AI book writer and an expert psychologist and coach.
    You have a keen eye for detail and a deep understanding of language, style, and grammar. 
    The user will provide the lyrics of a song mentioning the topic of personal development and growth. You will write a paragraph for each lyric line, embedding them in the text, not just adding them at the beginning of the paragraph. 
    IMPORTANT!! Ensure the tone and voice of the writing are strictly consistent with the Reference Material, using simple and clear wording.
    IMPORTANT!| don't mention the word "lyrics", "lyric", "lines", "line", or "reference material" in the response.
    make sure you write at least 600 characters for each lyric line.
    Only write your analysis once, avoid introductions, explanations, or instructions so that it can be easily copied and pasted, do not add a "fully edited version incorporating the suggestions"
    If you don't have access to the reMind book Reference Material, please say so in the response.
    `;
  
  
  const testFunction = () => {
    process.env.NODE_ENV === "development" && console.log("TEST", aiPrompt) 
  }
    if (!isGodMode(user)) {
      return <NoAccess />
    }

  return (
    <div style={{padding: "30px"}}>
      <BlueButton hide={hideTestButtons} text={"Test Button"} fn={testFunction}/>
      {isLoading ? (
        <div>Loading reference data...</div>
      ) : (
        <ClaudeAiCustomData 
          customData={customData} 
          systemPrompt={aiPrompt} 
          stream={true}
          strict={true}
          onSaveAiData={setAiData}
        />
      )}

    </div>
  )
}

export default BookWriting
